import logo from "../../asset/image/new/logo.png";

function MiniApp404() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col w-full">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#4fc3c8] via-[#3da8bf] to-[#5b8dd9] px-5 pt-12 pb-8 flex flex-col items-center">
        <div className="w-24 h-24 rounded-full bg-white/20 flex items-center justify-center mb-4 shadow-lg">
          <img src={logo} alt="Phukphan Logo" className="w-16 h-16 object-contain" />
        </div>
        <p className="text-white font-bold text-3xl tracking-wide">ผูกพันธุ์</p>
        <p className="text-white/80 text-sm mt-1 text-center">ตรวจสอบผลการตรวจทางห้องปฏิบัติการ</p>
      </div>

      {/* 404 Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-16 text-center">
        <div className="w-24 h-24 rounded-full bg-teal-50 flex items-center justify-center mb-6">
          <span className="text-4xl font-bold text-teal-400">404</span>
        </div>
        <p className="text-gray-700 font-semibold text-xl mb-2">ไม่พบหน้าที่ต้องการ</p>
        <p className="text-gray-400 text-sm max-w-xs">
          ลิงก์ที่คุณเปิดอาจไม่ถูกต้องหรือหน้านี้ไม่มีอยู่ในระบบ
        </p>
      </div>

      {/* Footer */}
      <div className="py-4 text-center">
        <p className="text-xs text-gray-400">ตรวจสอบผลการตรวจทางห้องปฏิบัติการ</p>
      </div>
    </div>
  );
}

export default MiniApp404;
